import React from "react";
import { m } from "framer-motion";
import { STDC_ICON_MAP, STDCEyeIcon } from "../MarketingIcons";

const shouldReduceMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const fadeInWhenVisible = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, margin: "100px" },
  transition: { duration: shouldReduceMotion ? 0.1 : 0.2, ease: "easeOut" },
};

const STDCFramework = ({ stdc }) => (
  <m.section
    className='pt-24 sm:py-20 xs:py-16 flex justify-center px-6 md:px-4 sm:px-5'
    style={{ contentVisibility: "auto", containIntrinsicSize: "0 800px" }}
    {...fadeInWhenVisible}
  >
    <div className='max-w-[1180px] w-full flex flex-col'>
      <div className=' rounded-t-md w-full px-10 !xs:px-0 lg:px-16 md:px-6 sm:px-5 py-16 sm:py-8 xs:py-6'>
        <div className='mx-auto text-left'>
          <h1 className='text-base font-semibold font-["Oxanium"] leading-7 !text-inaqgold !mb-2 '>
            {stdc.eyebrow}
          </h1>
          <h2 className='my-0 text-3xl font-300 font-rubik tracking-tight  !text-inaqpurple sm:text-2xl'>
            {stdc.headline}
          </h2>
        </div>
      </div>

      <div className='overflow-hidden'>
        {" "}
        <div className='relative rounded-md w-full px-10 lg:px-8 md:px-6 sm:px-5 py-16 sm:py-16 xs:py-12 overflow-hidden'>
          <div
            className='absolute inset-0 rounded-md'
            style={{
              background:
                "radial-gradient(ellipse at top left, #241025 20%, transparent 70%), radial-gradient(circle at bottom right, #1a0b1c 30%, #09010a 100%)",
            }}
          >
            <div className='grain-overlay'></div>
          </div>

          <div className='relative z-10 mx-auto text-left mb-8 sm:mb-12'>
            <h2 className='text-base text-center font-rubik leading-7 px-48 xs:px-2 md:px-16 mb-24 text-white !font-300 xs:text-sm xs:mb-6'>
              {stdc.intro}
            </h2>
          </div>
          <dl className='relative z-10 grid grid-cols-4 lg:grid-cols-2 xs:grid-cols-1 gap-x-12 gap-y-16 lg:px-12 sm:gap-y-12 xs:gap-y-16 px-4 xs:px-8'>
            {stdc.items.map((item, i) => {
              const Icon = STDC_ICON_MAP[item.icon] || STDCEyeIcon;
              const isFirst = i === 0;
              return (
                <div className='text-left' key={i}>
                  <dt className='flex flex-col items-start gap-y-3 sm:gap-y-6'>
                    <span
                      className={`flex h-10 w-10 items-center justify-center rounded-md bg-white${isFirst ? " stdc-icon" : ""}`}
                    >
                      {isFirst ? (
                        <Icon className='h-6 w-6 text-inaqpurple' aria-hidden='true' />
                      ) : (
                        <Icon />
                      )}
                    </span>
                    <span className='text-base font-semibold leading-7 text-white xs:text-sm stdc-title'>
                      {item.title}
                    </span>
                  </dt>
                  <dd className='mt-3 text-sm leading-7 text-gray-300 xs:text-sm'>
                    {item.body}
                  </dd>
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </div>
  </m.section>
);

export default STDCFramework;
